import { initI18n } from '@wix/wix-i18n-config';
import React, { useEffect, useMemo, useState } from 'react';
import defaultTranslations from '../assets/locale/messages_en.json';
import { DEFAULT_LOCALE } from '../constants';
import { TranslationsContext } from '../contexts';
const i18n = initI18n({
  locale: DEFAULT_LOCALE,
  asyncMessagesLoader: locale => {
    if (locale === DEFAULT_LOCALE) {
      return Promise.resolve(defaultTranslations);
    }
    return import(`../assets/locale/messages_${locale}.json`);
  }
});
const defaultTranslationFn = key => {
  return defaultTranslations[key] || key;
};
export const TranslationsProvider = _ref => {
  let {
    locale = DEFAULT_LOCALE,
    children
  } = _ref;
  const [translationFn, setTranslationFn] = useState(() => defaultTranslationFn);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsLoading(true);
    i18n.changeLanguage(locale, (_error, t) => {
      setTranslationFn(() => t);
      setIsLoading(false);
    });
  }, [locale]);
  const value = useMemo(() => ({
    t: translationFn,
    isLoading
  }), [translationFn, isLoading]);
  return /*#__PURE__*/React.createElement(TranslationsContext.Provider, {
    value: value
  }, children);
};
//# sourceMappingURL=TranslationsProvider.js.map